import styled from 'styled-components';
import { Input } from 'reactstrap';

const StyledInput = styled(Input)`
  &[type='text'],
  &[type='password'],
  &[type='date'],
  &[type='number'],
  &[type='email'] {
    // Gets rid of the Internet Explorer default "X" on input fields
    &::-ms-clear {
      height: 0;
      width: 0;
      display: none;
    }
    font-family: ${props => props.theme.fontFamily};
    color: ${props => {
      return props.valid === false
        ? props.theme.colors.red
        : props.theme.colors.black;
    }};
    border: 0.0625em solid
      ${props => {
        return props.valid === false
          ? props.theme.colors.red
          : props.theme.colors.black;
      }};
    height: 2em;
    width: ${props => props.theme.fullWidth};
    padding: 0 0.3em;
    border-radius: 0;
    background: none;

    &.is-valid:focus {
      border-color: ${props => props.theme.colors.black};
    }

    &:focus {
      box-shadow: ${props => props.theme.forms.input.focusOutline};
    }

    &:disabled {
      background: ${props => props.theme.colors.disabledInput};
    }
  }
`;

export default StyledInput;
